export const CORE_SERVICE_CATEGORY_CODES = ['builder', 'electrician', 'plumber', 'roofer'] as const;

type CoreServiceCategoryCode = (typeof CORE_SERVICE_CATEGORY_CODES)[number];

/**
 * The four core slots are a fixed, client-owned UX concept — they always render, in this order,
 * whatever the role catalog returns. Labels live here so a core slot can be shown without a role
 * from the API.
 */
export const CORE_SERVICE_CATEGORY_LABELS: Record<CoreServiceCategoryCode, string> = {
	builder: 'Builder',
	electrician: 'Electrician',
	plumber: 'Plumber',
	roofer: 'Roofer',
};
